// extracted by mini-css-extract-plugin
export default {"sync-now__wrapper":"Sync_sync-now__wrapper__E-Z+I","sync-now__text":"Sync_sync-now__text__pifE5","sync-now__last-sync":"Sync_sync-now__last-sync__4gewa"};